import React from "react";
import TabTemplate from "../../../_shoru_shared_library/template/TabTemplate";
import castingChoicesRouter from "./castingChoicesRouter";

function CastingChoicesTab(props) {

  return (
    <TabTemplate 
      router={castingChoicesRouter}
      passData={props.passData}
    />
  )

}

export default CastingChoicesTab;